// ACTION
export const MODAL = {
  CHANGE_STATUS: 'CHANGE_STATUS',
  CHANGE_TYPE: 'CHANGE_TYPE',
  SAVE_INFO: 'SAVE_INFO',
  DELETE_INFO: 'DELETE_INFO'
};

// ACTION CREATORS
export function openModal() {
  document.querySelector('.site-content').classList.add('_blur');
  return async (dispatch) => {
    dispatch({
      type: MODAL.CHANGE_STATUS,
      status: true
    })
  }
}

export function closeModal() {
  document.querySelector('.site-content').classList.remove('_blur');
  return async (dispatch) => {
    dispatch({
      type: MODAL.CHANGE_STATUS,
      status: false
    })
    await dispatch(deleteInfo())
  }
}

export function changeTypeOfModal(modal) {
  return async (dispatch) => {
    dispatch({
      type: MODAL.CHANGE_TYPE,
      modal
    })
  }
}

export function saveModalInfo(info) {
  return async (dispatch) => {
    dispatch({
      type: MODAL.SAVE_INFO,
      info
    })
  }
}

export function deleteInfo() {
  return async (dispatch) => {
    dispatch({
      type: MODAL.DELETE_INFO
    })
  }
}